import type { RouteRecordRaw } from 'vue-router';

// B5.1 my-bids route + B7.1/B7.1a sign-in routes. The recovery slice is
// folded under my-bids in this codebase because both surfaces share the
// "magic-link / session-recovery" flow; architecture's separate
// `features/recovery` is a future split target (frontend-structure §11).
export const routes: RouteRecordRaw[] = [
  {
    path: '/:slug/my-bids',
    name: 'my-bids',
    component: () => import('./pages/MyBidsPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/:slug/sign-in',
    name: 'sign-in',
    component: () => import('./pages/SignInPage.vue'),
  },
  {
    // GT1-546 — the texted sign-in link. No slug: the grant already names its
    // event, and spelling it out cost the SMS the slug's length plus twelve
    // characters of a 160-character budget. The exchange hands the slug back
    // and SignInPage routes from there.
    //
    // This is an addition, not a replacement. `/:slug/sign-in?token=` above
    // stays: sign-in grants minted into notification emails (signInGrants.ts)
    // live until the auction closes plus seven days, so links in the old shape
    // sit in inboxes long after this one ships.
    path: '/si/:token',
    name: 'sign-in-short',
    component: () => import('./pages/SignInPage.vue'),
  },
  {
    path: '/:slug/sign-in/sent',
    name: 'sign-in-sent',
    component: () => import('./pages/SignInSentPage.vue'),
  },
];
